import { ScreenSharingStatus } from '@agent/agent-interface/contact-view/chat/model/screen-sharing-info';
import { ChatSocketService } from '@agent/agent-interface/contact-view/chat/services/chat-socket.service';
import { OpenTokService } from '@agent/agent-interface/contact-view/chat/services/open-tok.service';
import { ScreenSharingService } from '@agent/agent-interface/contact-view/chat/services/screen-sharing.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ProfileService, UntilDestroy, untilDestroyed } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'chat-mirror',
  templateUrl: 'chat-mirror.component.html',
  styleUrls: ['./chat-mirror.component.scss'],
})
export class ChatMirrorComponent implements OnInit {
  private screenSharingContainer: HTMLElement;
  public enableMirroring: boolean = false;
  public adjustedView: boolean = true;

  @Input()
  public extendedMirror: boolean = false;
  @Output()
  public readonly extended = new EventEmitter<any>();

  constructor(
    private readonly chatSocketService: ChatSocketService,
    private readonly screenSharingService: ScreenSharingService,
    private readonly openTokService: OpenTokService,
    private readonly profileService: ProfileService
  ) {}

  public get chatHasOngoingSharingSession(): boolean {
    const activeChat = this.chatSocketService.activeChat;
    return activeChat ? activeChat.screenSharingInfos.status === ScreenSharingStatus.ONGOING : false;
  }

  public get screenSharingDemandPending(): boolean {
    const activeChat = this.chatSocketService.activeChat;
    return activeChat ? activeChat.screenSharingInfos.status === ScreenSharingStatus.PENDING_INVITATION : false;
  }

  ngOnInit(): void {
    const container = document.getElementById('chat-mirror-main');
    if (container) {
      const $elCandidates = container.getElementsByClassName('screen-sharing-container');
      if ($elCandidates.length !== 1) {
        throw new Error('The CSS request "#chat-mirror-main .screen-sharing-container" must return one element');
      }
      this.screenSharingContainer = $elCandidates.item(0) as HTMLElement;
    }
    this.openTokService.streamSubscribed$.pipe(untilDestroyed(this)).subscribe(value => {
      this.screenSharingContainer.innerHTML = '';
      if (value && value.chat && value.chat === this.chatSocketService.activeChat) {
        this.screenSharingContainer.appendChild(value.$el);
      }
    });
    if (this.profileService.hasPermission('CSR_CHAT_INCOMING::mirroring:activate')) {
      this.enableMirroring = true;
    }
  }

  public askForScreenSharing(): void {
    this.screenSharingService.askForScreenSharingSession();
  }

  public get hasScreenSharing(): boolean {
    const chat = this.chatSocketService.chatList.find(
      e =>
        e.screenSharingInfos.status === ScreenSharingStatus.ONGOING ||
        e.screenSharingInfos.status === ScreenSharingStatus.PENDING_INVITATION
    );
    if (chat != null) {
      return this.chatSocketService.chatList.length > 1 && chat !== this.chatSocketService.activeChat;
    }
    return false;
  }

  public get visitorHasNoCapabilityForScreenSharing(): boolean {
    const activeChat = this.chatSocketService.activeChat;
    return !!activeChat && !activeChat.checkCapabilityForScreenSharing;
  }

  public onExtend() {
    this.extended.emit();
  }

  public changeView() {
    this.openTokService.changeResolution();
    this.adjustedView = !this.adjustedView;
  }

  getConferenceButton() {
    const activeChat = this.chatSocketService.activeChat;
    return activeChat && activeChat.conference;
  }
}
